export const API_URL               = process.env.REACT_APP_API_URL;
export const WS_CHANGES_URL        = process.env.REACT_APP_WS_CHANGES_URL;
export const WS_PRINT_URL          = process.env.REACT_APP_WS_PRINT_URL;
export const ENVIRONMENT           = process.env.REACT_APP_ENVIRONMENT;
export const HONEY_BADGER_API_KEY  = process.env.REACT_APP_HONEY_BADGER_API_KEY;
export const HONEY_BADGER_REVISION = process.env.REACT_APP_HONEY_BADGER_REVISION;
